import { useSearchParams } from 'react-router-dom'
//import AjustesEmpresa from '../components/modules/views/dashboard/Ajustes/AjustesEmpresa/Index'
import Tabs from '../components/modules/tabs/Tabs'
import { USE_NEW_PLAN_LOGIC } from '../components/utils/constant'
import PlanDeCuentas from '../components/modules/views/dashboard/Ajustes/PlanDeCuentas/Components/PlanDeCuentas.js'
import CentroCostos from '../components/modules/views/dashboard/Ajustes/CentroCostos/Index'
import Integraciones from '../components/modules/views/dashboard/Ajustes/Integraciones/Index'
import Pagos from '../components/modules/views/dashboard/Ajustes/Pagos/Index'
//import AjustesAvanzados from '../components/modules/views/dashboard/Ajustes/Avanzados/Index'

import Layout from '../components/layouts/index'

import { FormInviteUser } from '../components/layouts/header/settings/tabs/users/FormInvitateUser'
import { UsersList } from '../components/layouts/header/settings/tabs/users/UsersList'
import { Paper } from '../../src/components/modules/ui/index'

const TAB_SLUGS = [
  'plan-cuentas',
  'usuarios',
  'centro-costos',
  'integraciones',
  ...(USE_NEW_PLAN_LOGIC ? ['pagos'] : []),
  'ajustes-avanzados'
]

const data = [
  /*{
    title: 'Ajustes de la Empresa',
    content: <AjustesEmpresa />
  },*/
  {
    title: 'Plan de cuentas',

    content: (
      <Paper>
        <PlanDeCuentas />
      </Paper>
    )
  },
  {
    title: 'Usuarios',
    content: (
      <div
        className="p-4 sm:p-6 pb-10 sm:pb-12 mt-6 bg-bg rounded-card shadow-card flex flex-col overflow-auto font-sans border border-border"
        style={{ minHeight: 'calc(100vh - 8.7rem)' }}
      >
        <div className="flex flex-col lg:flex-row gap-6 sm:gap-8 h-full">
          
          {/* Formulario */}
          <div className="relative flex flex-col w-full lg:w-[36%] bg-surface border border-border shadow-card rounded-card p-6 sm:p-7 overflow-visible">
            <div className="absolute -top-10 -right-10 h-24 w-24 rounded-full bg-primary/10 blur-2xl" />
            <div className="flex items-start justify-between gap-4 mb-4">
              <div>
                <h3 className="text-lg font-semibold text-text">
                  Invitar nuevo usuario
                </h3>
                <p className="text-xs text-muted mt-1">
                  Agrega un colaborador al equipo
                </p>
              </div>
            </div>
            <div className="h-[2px] w-10 bg-primary/70 rounded-full mb-4" />
            <FormInviteUser />
          </div>

          {/* Tabla */}
          <div className="relative flex flex-col w-full lg:w-2/3 bg-surface border border-border shadow-card rounded-card p-6 sm:p-7 overflow-auto">
            <div className="absolute -bottom-10 -right-10 h-28 w-28 rounded-full bg-primary/10 blur-2xl" />
            <div className="flex items-start justify-between gap-4 mb-4">
              <div>
                <h3 className="text-lg font-semibold text-text">
                  Usuarios Autorizados
                </h3>
                <p className="text-xs text-muted mt-1">
                  Gestiona accesos y permisos del equipo
                </p>
              </div>
            </div>
            <div className="h-[2px] w-10 bg-primary/70 rounded-full mb-4" />
            <UsersList />
          </div>

        </div>
      </div>
    )
  },
  {
    title: 'Centro de costos',

    content: (
      <Paper>
        <CentroCostos />
      </Paper>
    )
  },
  {
    title: 'Integraciones',

    content: (
      <Paper>
        <Integraciones />
      </Paper>
    )
  },
  ...(USE_NEW_PLAN_LOGIC
    ? [{ title: 'Planes', content: <Pagos /> }]
    : []),
 /*{
    title: 'Ajuste Avanzados',
    content: (
      <Paper>
        <AjustesAvanzados />
      </Paper>
    )
  }*/
]

export default function Ajustes() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const tabIndex = TAB_SLUGS.includes(tabParam) ? TAB_SLUGS.indexOf(tabParam) : 0

  const handleTabChange = (index) => {
    setSearchParams({ tab: TAB_SLUGS[index] }, { replace: true })
  }

  return (
    <Layout>
      <div className='font-sans'>
        <Tabs
          tabs={data}
          activeIndex={tabIndex}
          onTabClick={handleTabChange}
        />
      </div>
    </Layout>
  )
}
